import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import { rgba } from 'polished';

import { COLOR_BLACK, COLOR_WHITE, COLOR_RED, COLOR_GREEN } from '../../assets/styles/colors';

export const SmallTextSC = styled.small`
  color: ${COLOR_BLACK};
  font-size: 14px;
  margin-bottom: 0;
  display: inline-block;
  &.white {
    color: ${COLOR_WHITE};
  }
  &.grey {
    color: ${rgba(COLOR_WHITE, 0.6)};
  }
  &.green {
    color: ${COLOR_GREEN};
  }
  &.red {
    color: ${COLOR_RED};
  }
  &.dark-grey {
    color: ${rgba(COLOR_WHITE, 0.4)};
  }
  &.black-transparent {
    color: ${rgba(COLOR_BLACK, 0.6)};
  }
  &.black-transparent-lighter {
    color: ${rgba(COLOR_BLACK, 0.4)};
  }
  &.transparented {
    opacity: 0.6;
  }
  &.bolder {
    font-weight: 600;
  }
  &.bold {
    font-weight: bold;
  }
  &.smaller {
    font-size: 12px;
  }
  &.uppercase {
    text-transform: uppercase;
  }
  &.chart-grey {
    color: #83828f;
  }
  &.text-justify {
    text-align: justify;
  }
  &.bigger {
    font-size: 15px;
    line-height: 21px;
  }
  &.block {
    display:block;
  }  
  &.margin-top-15 {
    margin-top:15px;
  } 
`;

const SmallText = (props) => {
  const { children, className, ...rest } = props;
  const customClass = classNames({ [className]: className !== '' });

  return (
    <SmallTextSC className={customClass} {...rest}>
      {children}
    </SmallTextSC>
  );
};

SmallText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

SmallText.defaultProps = {
  className: '',
};

export default SmallText;
